// Face position in each portrait, measured with the Windows face detector.
// fx/fy: face centre as a fraction of image width/height; fh: face height as a
// fraction of image height; w/h: source pixels. Used by COMPONENTS/PORTRAIT to
// crop every photo so faces share the same size and position.
// Regenerate when photos are added or replaced.

export const portraitFaces = {
  "Heather G Aguirre, DO": {
    "w": 1254,
    "h": 1254,
    "fx": 0.5032,
    "fy": 0.3636,
    "fh": 0.4338,
    "openTop": false
  },
  "Jason A. Yoho, MD": {
    "w": 433,
    "h": 577,
    "fx": 0.514,
    "fy": 0.3511,
    "fh": 0.435,
    "openTop": false
  },
  "Andrew D. Posey, DO": {
    "w": 497,
    "h": 502,
    "fx": 0.5008,
    "fy": 0.3472,
    "fh": 0.4068,
    "openTop": false
  },
  "Adam S. Plotkin, MD": {
    "w": 450,
    "h": 578,
    "fx": 0.5218,
    "fy": 0.2495,
    "fh": 0.3699,
    "openTop": false
  },
  "Matthew Uhde, DO": {
    "w": 450,
    "h": 579,
    "fx": 0.5368,
    "fy": 0.2259,
    "fh": 0.3693,
    "openTop": false
  },
  "Jason M. Mendivil, DPM": {
    "w": 367,
    "h": 436,
    "fx": 0.4843,
    "fy": 0.2742,
    "fh": 0.4222,
    "openTop": false
  },
  "Lyssa Neida Ochoa, MD": {
    "w": 429,
    "h": 480,
    "fx": 0.4962,
    "fy": 0.3666,
    "fh": 0.451,
    "openTop": false
  },
  "Marcus L. Gitterle, M.D. FACCWS": {
    "w": 500,
    "h": 500,
    "fx": 0.4829,
    "fy": 0.4953,
    "fh": 0.5782,
    "openTop": true
  },
  "Nir Joseph Hus, M.D., Ph.D., FACS": {
    "w": 500,
    "h": 500,
    "fx": 0.5056,
    "fy": 0.4304,
    "fh": 0.6672,
    "openTop": false
  },
  "V. Joseph Ballarini, D.O": {
    "w": 474,
    "h": 595,
    "fx": 0.4758,
    "fy": 0.4145,
    "fh": 0.4929,
    "openTop": false
  },
  "R. Scott Strahlman, M.D., FAAFP": {
    "w": 170,
    "h": 211,
    "fx": 0.4759,
    "fy": 0.437,
    "fh": 0.4986,
    "openTop": true
  },
  "William Saway, M.D., FACP": {
    "w": 201,
    "h": 251,
    "fx": 0.5142,
    "fy": 0.3223,
    "fh": 0.439,
    "openTop": true
  },
  "James R. Bellor, M.D.": {
    "w": 198,
    "h": 244,
    "fx": 0.5303,
    "fy": 0.3754,
    "fh": 0.459,
    "openTop": true
  },
  "John B. Waits, M.D., FAAFP": {
    "w": 369,
    "h": 368,
    "fx": 0.4924,
    "fy": 0.5072,
    "fh": 0.6204,
    "openTop": false
  },
  "David J. Hecker, M.D.": {
    "w": 574,
    "h": 580,
    "fx": 0.4952,
    "fy": 0.3666,
    "fh": 0.4886,
    "openTop": false
  },
  "Melanie S. Hecker, M.D., M.B.A.": {
    "w": 185,
    "h": 162,
    "fx": 0.4716,
    "fy": 0.4596,
    "fh": 0.4093,
    "openTop": true
  },
  "Jeffrey Wolkowicz, M.D.": {
    "w": 458,
    "h": 544,
    "fx": 0.4103,
    "fy": 0.2625,
    "fh": 0.325,
    "openTop": true
  },
  "Adam Maciak": {
    "w": 960,
    "h": 960,
    "fx": 0.526,
    "fy": 0.3609,
    "fh": 0.3885,
    "openTop": false
  },
  "Roshni Dasgupta": {
    "w": 960,
    "h": 960,
    "fx": 0.537,
    "fy": 0.4198,
    "fh": 0.4396,
    "openTop": true
  },
  "Jennifer Hilton": {
    "w": 960,
    "h": 960,
    "fx": 0.4901,
    "fy": 0.4646,
    "fh": 0.5333,
    "openTop": true
  }
};
